import { Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { backofficeLinks } from "@/components/lib/SidebarLinks";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "@radix-ui/react-separator";
import KababListTabs from "@/components/menu-management/kabab/kabab-list/kabab-list-tabs";
import DraftListTabs from "@/components/menu-management/kabab/kabab-list/draft-list-tabs";
import { useDispatch, useSelector } from "react-redux";
import useAuth from "@/hooks/useAuth";
import TableSkeleton from "@/components/skeleton/table-skeletion";
import {
  fetchAllKebabs,
  clearKebabMessages,
} from "@/redux/slice/menu-manage-slice/kebab-slice";
import { clearItemVariants } from "@/redux/slice/essential-menu-slice/variants-slice";
import hasPermission from "@/hooks/hasPermission";

function Kabab() {
  const dispatch = useDispatch();
  const { user } = useAuth();
  const { getLoading } = useSelector((state) => state.menuManage.kebab);

  useEffect(() => {
    dispatch(fetchAllKebabs(user?.restaurant_id));
    dispatch(clearKebabMessages());
    dispatch(clearItemVariants());
  }, [user?.restaurant_id]);

  if (getLoading) return <TableSkeleton links={backofficeLinks} />;
  return (
    <Layout2
         pageName={{ title: "Kebab List" }}
      paths={[
        { name: "home", path: "/home" },
        { name: "Back Office", path: "/backoffice/overview" },
        { name: "Menu Management", path: "/backoffice/menu/drinks" },
        { name: "Kebab", path: "/backoffice/menu/kebab" },
      ]}
      LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}
    >
      <div className="container flex flex-col gap-4 mt-5">
   <div className="flex justify-end items-start md:items-center md:flex-row flex-col  w-full">
         
          {hasPermission("back_office.menu_management.create_kebab") && (
            <Link to={"/backoffice/menu/kebab/create"}>
              <Button>
                <Plus /> Create Kebab
              </Button>
            </Link>
          )}
        </div>
        <Tabs valueKey="menu-kebab" className="bg-transparent relative" defaultValue="drink">
          <TabsList className="grid grid-cols-6 w-full">
            <Separator className="absolute top-8 " />
            <TabsTrigger className="bg-transparent" value="drink">
              Kebab List
            </TabsTrigger>
            <TabsTrigger value="draft">Draft List</TabsTrigger>
          </TabsList>
          <Separator className=" absolute top-8 w-full h-[1px] bg-neutral-700" />
          <KababListTabs />
          <DraftListTabs />
        </Tabs>
      </div>
    </Layout2>
  );
}

export default Kabab;
